import Vue from 'vue';
import Vuex from 'vuex';

import {AppStore} from '@/store/App.store';
import {ApiStore} from '@/store/Api.store';
import {DashboardStore} from '@/store/Dashboard.store';
import {NotificationStore} from '@/store/Notification.store';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import SystemRegionStore from '@/store/system/SystemRegion.store';
import SystemStatsStore from '@/store/system/SystemStats.store';
import SystemLogStore from '@/store/system/SystemLogs.store';
import SystemUpgradeStore from '@/store/system/SystemUpgrade.store';
import SystemUpdateStore from '@/store/system/SystemUpdate.store';
import SystemStorageStore from '@/store/system/SystemStorage.store';

import NetworkNetworkingStore from '@/store/network/NetworkNetworking.store';
import NetworkDevicesStore from '@/store/network/NetworkDevices.store';
import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';
import NetworkProfilesStore from '@/store/network/NetworkProfiles.store';
import NetworkSafeUpdateStore from '@/store/network/NetworkSafeUpdate.store';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';
import LoraForwardersStore from '@/store/lora/LoraForwarders.store';

import LoraForwarderUdpStore from '@/store/lora/LoraForwarderUdp.store';
import LoraForwarderBasicStationStore from '@/store/lora/LoraForwarderBasicStation.store';
import LoraForwarderLoriotStore from '@/store/lora/LoraForwarderLoriot.store';
import LoraForwarderChirpStackStore from '@/store/lora/LoraForwarderChirpStack.store';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export function loadStore() {
  return new Vuex.Store({
    modules: {
      AppStore,
      ApiStore,
      DashboardStore,
      NotificationStore,

      SystemInfoStore,
      SystemRegionStore,
      SystemStatsStore,
      SystemLogStore,
      SystemUpgradeStore,
      SystemUpdateStore,
      SystemStorageStore,

      NetworkNetworkingStore,
      NetworkDevicesStore,
      NetworkConnectionsStore,
      NetworkProfilesStore,
      NetworkSafeUpdateStore,

      LoraHardwareStore,
      LoraForwardersStore,
      LoraForwarderUdpStore,
      LoraForwarderBasicStationStore,
      LoraForwarderChirpStackStore,
      LoraForwarderLoriotStore,
    },
    strict: debug,
  });
}
